(() => {
  const header = document.querySelector('.welcome-header');
  if (!header) return;
  const measure = () => document.documentElement.style.setProperty('--header-height', `${header.getBoundingClientRect().height}px`);
  new ResizeObserver(measure).observe(header);
  measure();
  let dialogTrigger;
  document.querySelectorAll('[data-open-dialog]').forEach(button => button.addEventListener('click', () => {
    const dialog = document.getElementById(button.dataset.openDialog);
    dialogTrigger = button;
    dialog.style.setProperty('--dialog-top', `${Math.max(0, header.getBoundingClientRect().bottom)}px`);
    dialog.showModal();
    document.documentElement.classList.add('welcome-dialog-open');
    const input = dialog.querySelector('input[type="search"]');
    if (input) input.focus();
  }));
  document.querySelectorAll('.welcome-dialog').forEach(dialog => {
    dialog.addEventListener('keydown', event => {
      if (event.key === 'Escape') { event.preventDefault(); dialog.close(); }
    });
    dialog.querySelector('[data-close-dialog]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => {
      const rect = dialog.getBoundingClientRect();
      if (event.target === dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) dialog.close();
    });
    dialog.addEventListener('close', () => {
      document.documentElement.classList.remove('welcome-dialog-open');
      dialogTrigger?.focus({preventScroll: true});
    });
  });
  matchMedia('(min-width: 901px)').addEventListener('change', event => {
    if (event.matches) document.getElementById('welcome-menu').close();
  });
  let frame;
  const stop = () => cancelAnimationFrame(frame);
  ['wheel', 'touchstart', 'pointerdown', 'keydown'].forEach(event => window.addEventListener(event, stop, {passive: true}));
  document.addEventListener('click', async event => {
    const copy = event.target.closest('[data-copy-code]');
    if (copy) {
      const status = document.querySelector('.welcome-copy-status');
      try {
        await navigator.clipboard.writeText(copy.dataset.copyCode);
        status.textContent = 'Copied. Use DADDY10% at checkout.';
        copy.querySelector('.welcome-copy-label').textContent = 'Copied';
      } catch (_) { status.textContent = 'Your code is DADDY10%. Enter it at checkout.'; }
      return;
    }
    const link = event.target.closest('a[href^="#"]');
    if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    const target = document.getElementById(link.hash.slice(1));
    if (!target) return;
    event.preventDefault();
    stop();
    if (target.tagName === 'DETAILS') target.open = true;
    const start = scrollY;
    const end = target.id === 'welcome-main' ? 0 : Math.max(0, Math.min(target.getBoundingClientRect().top + scrollY - header.getBoundingClientRect().height - 20, document.documentElement.scrollHeight - innerHeight));
    const finish = () => {
      const focus = target.tagName === 'DETAILS' ? target.querySelector('summary') : target;
      if (!focus.hasAttribute('tabindex')) focus.setAttribute('tabindex', '-1');
      focus.focus({preventScroll: true});
      history.replaceState(null, '', link.hash);
    };
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) { window.scrollTo(0, end); finish(); return; }
    const began = performance.now();
    const duration = Math.min(2400, Math.max(1400, Math.abs(end - start) * .55));
    const animate = now => {
      const t = Math.min(1, (now - began) / duration);
      const ease = t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
      window.scrollTo(0, start + (end - start) * ease);
      if (t < 1) frame = requestAnimationFrame(animate); else finish();
    };
    frame = requestAnimationFrame(animate);
  });
  // Keep campaign attribution on genuine, visible links to the main store.
  const campaign = new URLSearchParams(location.search);
  const keys = ['utm_source','utm_medium','utm_campaign','utm_content','utm_term','utm_id','fbclid'];
  const searchForm = document.querySelector('.welcome-search form');
  keys.forEach(key => { if (campaign.has(key)) { const input = document.createElement('input'); input.type = 'hidden'; input.name = key; input.value = campaign.get(key); searchForm.append(input); } });
  document.querySelectorAll('a[href^="https://downunderthunder.com.au/"]').forEach(link => {
    const url = new URL(link.href);
    const destination = url.pathname.startsWith('/discount/') ? new URL(url.searchParams.get('redirect') || '/', url.origin) : url;
    keys.forEach(key => { if (campaign.has(key)) destination.searchParams.set(key, campaign.get(key)); });
    if (destination !== url) url.searchParams.set('redirect', destination.pathname + destination.search);
    link.href = url.href;
  });
})();
